module.exports = __webpack_public_path__ + "img/weingutloewenstein_1.34f979ac.jpg";